
import { delAquaDev } from "./portalDelAquaDev";
import { delAreas } from "./portalDelAreas";
import { delOysterBounds } from "./portalDelOysterBound";
import { delTongers} from "./portalDelTongers";
import { mullicaSeed } from "./portalMullicaSeed";
import { shellfishLeases } from "./portalShellfishLeases";
import {shellfishSections} from './portalShellfishSections'

export const existingBeds = {
  id: 'existing-beds',
  title: "Existing Beds",
  type: 'group',
  items: [
    // atlanticLeases,
    // atlRelay,
    delAquaDev,
    delAreas,
    // delOysterBeds,
    delOysterBounds,
    // delShellLeases,
    delTongers,
    // greatBay,
    // kings,
    mullicaSeed,
    shellfishLeases,
    shellfishSections,
    // tidelands,
  ],
}



